
import {
  Vue,
  Component,
} from 'vue-property-decorator';
import Pagination from '@/components/board/pagination.vue';
import { searchCompany, searchYoutubeList } from '@/api/company';
import { ICompanySearch, ISearchKeyword } from '@/types/company';
import { UserModule } from '@/store/user';

@Component({
  name: 'CompanyList',
  components: {
    Pagination,
  },
})

export default class extends Vue {
  private fetchYoutubeList() {
    let apiPage = this.listQuery.page;
    if (apiPage < 0) apiPage = 0;

    const searchParams: ISearchKeyword = {
      page: apiPage,
      size: this.listQuery.size,
      keyword: this.listQuery.searchValue,
    };

    searchYoutubeList(searchParams)
      .then((ures) => {
        this.youtubeList = ures.data.content; // API 응답 내용(유튜브 링크 목록)
        this.totalElements = ures.data.totalElements;
        this.totalPages = ures.data.totalPages;

        // 영상 제목 가져오기 처리
        this.youtubeList.forEach((item: any) => {
          if (item.youtubeLink) {
            const videoId = item.youtubeLink;
            this.fetchYoutubeTitle(videoId);
          }
        });
      })
      .catch((error) => {
        console.error('유튜브 검색 실패:', error);
      });
  }

  mounted() {
    this.init();
  }

  private listQuery: any = {
    page: 0,
    size: 9,
    searchValue: '',
    sort: 'progress',
    progress: 0,
    categories: [],
    target: '',
    categories2: '',
    startDate: '',
    endDate: '',
  };

  private companyList: any = [];

  private totalElements = 0;

  private totalPages = 1;

  private youtubeTitles: { [key: string]: string } = {};

  private youtubeList: any[] = [];

  get imagePath() {
    return `${process.env.VUE_APP_COMMON_API}/attached-file`;
  }

  private async init() {
    this.listQuery.page = 0;
    this.fetchYoutubeList();
  }

  // 검색 버튼 클릭 시
  private handleSearch() {
    this.listQuery.page = 0;
    this.fetchYoutubeList();
  }

  // 페이지 변경 시
  private handleChangePage(page: number) {
    this.listQuery.page = page;
    this.fetchYoutubeList();
  }

  // 초기화 버튼
  private searchReset() {
    this.listQuery.searchValue = '';
    // this.selectedGubun = 'I'; // 삭제됨: 구분 초기화 로직 제거
    this.handleSearch();
  }

  private getThumnail(inputValue: string) {
    if (inputValue.startsWith('http')) return inputValue;
    return `${this.imagePath}/${inputValue}`;
  }

  private getNumber(index: number) {
    const totalSize = (this.listQuery.page - 1) * this.listQuery.size;
    return this.totalElements - totalSize - index;
  }

  private getYoutubeWatchUrl(videoId: string) {
    if (!videoId) return '#';
    // 영상 ID를 이용해 시청 URL 반환
    return `https://www.youtube.com/watch?v=${videoId}`;
  }

  private getThumbnailFromId(videoId: string) {
    if (!videoId) return '';
    // hqdefault.jpg (고화질, 480x360)
    return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  }

  private async fetchYoutubeTitle(videoId: string) {
    if (!videoId || this.youtubeTitles[videoId]) return; // 이미 있으면 패스

    try {
      // noembed는 유튜브 주소를 주면 제목 등의 메타데이터를 줍니다.
      const response = await fetch(`https://noembed.com/embed?url=https://www.youtube.com/watch?v=${videoId}`);
      const data = await response.json();

      // Vue 2의 반응성(Reactivity)을 위해 $set 사용 권장
      this.$set(this.youtubeTitles, videoId, data.title);
    } catch (e) {
      console.error('유튜브 제목 로딩 실패', e);
    }
  }

  private truncateText(text: string, length: number): string {
    if (!text) return '';
    if (text.length <= length) return text;
    return `${text.substring(0, length)}...`;
  }
}
